import { HoverCard, HoverCardContent, HoverCardTrigger } from '@chain-zen/ui'

import type { TVisibilityAppSource } from '../../../types/tracking'
import { VisibilityAppInfo } from './visibility-app-info'
import { VisibilityAppTooltip } from './visibility-app-tooltip'

interface ITiveDeviceSourceProps {
  shipmentID: string
  trackingSourceData: TVisibilityAppSource
}

/**
 * VisibilityAppSource displays the visibility app data for the shipment.
 */
export const VisibilityAppSource = (props: ITiveDeviceSourceProps) => {
  const { trackingSourceData, shipmentID } = props

  return (
    <HoverCard>
      <HoverCardTrigger className="w-full">
        <div className="w-full">
          <VisibilityAppInfo trackingSourceData={trackingSourceData} shipmentID={shipmentID} />
        </div>
      </HoverCardTrigger>
      <HoverCardContent className="w-full text-sm" side="top">
        <VisibilityAppTooltip trackingSourceData={trackingSourceData as TVisibilityAppSource} />
      </HoverCardContent>
    </HoverCard>
  )
}
